<template>
  <router-view />
</template>

<script>
export default {
  name: 'card-shipping-fees-pages-container',
};
</script>
